/*
  Rabatmotor qty-tiers widget (vanilla web component, samme konvention som temaet).
  UI: kollapset pack-selector ("10-pack ⌄" + pris/unit), opklappeligt panel med
  radio-rækker ("Minimize"), og en Add to cart-knap — Haypp-stil.

  - Alle <qty-tiers> på siden batches til ÉT kald mod appen (debounced 60 ms).
  - Ingen regel / fejl / timeout → elementet forbliver tomt. Storefront må aldrig knække.
   - PDP-tilstand (data-pdp, main-product.liquid): åben tier-liste uden egen
     add-to-cart — rækker sætter temaets quantity-input, og temaets/stickyens
     native knap køber. Renderes den, skjules temaets pris + antalsvælger via
     .main-product--qt; svarer appen ikke, står temaets egne kontroller som de er.
  - Add to cart proxy'er temaets egen quick-buy-form i kortet (sætter quantity og
    klikker temaets submit-knap), så AJAX/cart-drawer er 100 % tema-nativt.
    Temaets egen quick-buy skjules via CSS når widget'en er aktiv (.qty-tiers-rendered).
*/
(function () {
  'use strict';

  if (customElements.get('qty-tiers')) return;

  var queue = [];
  var flushTimer = null;
  var openWidget = null; // kun ét åbent panel ad gangen

  // ---------- Intelligems-testgrupper ----------
  // Regler kan have gruppe-scopede procent-overrides (appens "Under Intelligems-
  // test"). Vi aflæser den besøgendes tildelinger og sender ID'erne med i
  // offers-kaldet. Findes intet (ingen test, adblock, ingen consent, timeout)
  // sendes tom liste → appen svarer med basisreglerne. Fail-safe hele vejen.
  var igReady = false;
  var igVariationIds = [];
  var igSentGroups = null; // hvad seneste offers-kald blev sendt med (sorteret join)
  var igRefetches = 0; // værn mod re-fetch-løkker
  window.addEventListener('ig:ready', function () { igReady = true; });
  // Offer-/personalization-tests broadcaster variation-tildelinger som event —
  // detail-formatet er udokumenteret, så vi samler defensivt alle id-lignende
  // felter OG fejer igData igen (tildelingen ER gemt dér når eventen fyrer).
  window.addEventListener('ig:variationAssignments', function (event) {
    try {
      var detail = event && event.detail;
      var list = detail && (detail.assignments || detail.variationAssignments || detail);
      (Array.isArray(list) ? list : []).forEach(function (a) {
        var id = a && (a.variationId || a.variation || a.id);
        if (typeof id === 'string' && id && igVariationIds.indexOf(id) === -1) igVariationIds.push(id);
      });
    } catch (e) { /* aldrig lade Intelligems-data vælte widget'en */ }
    igRefetchIfChanged();
  });

  function collectIgGroups() {
    var ids = {};
    // Er Intelligems slukket, sendes der INGEN grupper — heller ikke fra gamle
    // tildelinger. Tildelingen ligger i localStorage/cookie "ig-vars" og bliver
    // liggende for evigt i browseren; uden dette tjek ville en tidligere
    // testdeltager blive ved med at se (og efter motor-flippet blive opkrævet)
    // testens procenter, længe efter testen var slut.
    if (!igOnPage()) return [];
    try {
      var d = window.igData;
      var user = d && d.user;
      var listFn = user && (user.getExperiments || user.getExperiences);
      if (user && typeof listFn === 'function') {
        (listFn.call(user) || []).forEach(function (experiment) {
          if (!experiment || !experiment.id) return;
          // Klassiske pris-/A/B-tests: testgruppe. Offer-tests: variation.
          try {
            var g = typeof user.getTestGroup === 'function' && user.getTestGroup(experiment.id);
            if (g && typeof g.id === 'string' && g.id) ids[g.id] = true;
          } catch (e) { /* enkelt eksperiment må ikke stoppe resten */ }
          try {
            var v = typeof user.getVariation === 'function' && user.getVariation(experiment.id);
            if (v && typeof v.id === 'string' && v.id) ids[v.id] = true;
          } catch (e) { /* ditto */ }
        });
      }
    } catch (e) { /* ingen igData → tom liste */ }
    // Intelligems' egen tildelings-tabel (localStorage "ig-vars"):
    // { <kort experience-id>: <kort variation-id> } — kort id = sidste segment
    // af UUID'et. Dækker OGSÅ offer-/kampagne-tests, som getExperiments() ikke
    // returnerer. "_UNASSIGNED"/"_EXCLUDED" frasorteres af hex-tjekket.
    try {
      var vars = JSON.parse(window.localStorage.getItem('ig-vars') || '{}');
      Object.keys(vars).forEach(function (key) {
        var value = vars[key];
        if (typeof value === 'string' && /^[a-f0-9]{12}$/i.test(value)) ids[value] = true;
      });
    } catch (e) { /* korrupt/blokeret storage → ignorer */ }
    igVariationIds.forEach(function (id) { ids[id] = true; });
    return Object.keys(ids);
  }

  // Ankommer tildelingen EFTER første offers-kald (preview henter draft-config
  // asynkront), gen-hentes tilbuddene så priserne opdateres til gruppens.
  // Kun når gruppe-sættet reelt har ændret sig, og max 3 gange.
  function igRefetchIfChanged() {
    if (igSentGroups === null || igRefetches >= 3) return;
    if (collectIgGroups().sort().join(',') === igSentGroups) return;
    igRefetches++;
    document.querySelectorAll('qty-tiers').forEach(function (el) {
      if (el._registered && el.dataset.appUrl && el.dataset.handle && !el.dataset.preview) enqueue(el);
    });
  }

  // Fase 2 (rabat-motor): spejl den besøgendes Intelligems-grupper som
  // kurv-attribut "_rm_ig_groups", så appens Discount Function kan give samme
  // gruppe-procenter i kurven. Harmløs i visnings-tilstand (attributten læses
  // bare ikke af nogen). Skrives kun når en kurv findes (cookie "cart="), eller
  // lige efter add-to-cart (force) — og kun når værdien reelt har ændret sig,
  // så vi ikke spammer /cart/update.js på hver sidevisning.
  function syncCartIgAttribute(igGroups, force) {
    try {
      var value = (igGroups || []).slice().sort().join(',');
      if (!force && !/(^|;\s*)cart=/.test(document.cookie)) return;
      var marker = null;
      try { marker = window.sessionStorage.getItem('rm-ig-attr'); } catch (e) { /* blokeret storage */ }
      if (marker === value) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _rm_ig_groups: value } })
      })
        .then(function (res) {
          if (!res.ok) return;
          try { window.sessionStorage.setItem('rm-ig-attr', value); } catch (e) { /* ignorer */ }
        })
        .catch(function () { /* fail-safe: robotten falder tilbage til basis-tiers */ });
    } catch (e) { /* må aldrig vælte widget'en */ }
  }

  document.addEventListener('click', function (event) {
    if (openWidget && !openWidget.contains(event.target)) openWidget.closePanel();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openWidget) openWidget.closePanel();
  });

  // Kort-bredden ændrer sig ved rotation/resize → mål enheds-prisen om, så den
  // stadig passer (ellers kan den begynde at flyde ud efter et viewport-skift).
  var refitTimer = null;
  // Webfonten kan blive faerdig EFTER foerste maaling → mål om én gang, naar den er klar.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      fitBatch(document.querySelectorAll('qty-tiers'));
    });
  }
  window.addEventListener('resize', function () {
    clearTimeout(refitTimer);
    refitTimer = setTimeout(function () {
      fitBatch(document.querySelectorAll('qty-tiers'));
      // Badges måles om af product-card-titles.js, der har sin egen resize-lytter.
    }, 150);
  });

  function enqueue(el) {
    queue.push(el);
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, 60);
  }

  var igWaited = false;

  // Ligger Intelligems overhovedet på siden? Uden app-embedet indlæses deres
  // bundle ikke, og så er der intet at vente på. Uden dette tjek kostede
  // ventetiden nedenfor det fulde sekund på HVER sidevisning, fra det øjeblik
  // Intelligems blev slukket — for ig:ready kommer aldrig.
  function igOnPage() {
    if (window.igData) return true;
    try {
      return !!document.querySelector('script[src*="intelligems"]');
    } catch (e) {
      return false; // fail-safe: hellere hente tiers straks end at vente forgæves
    }
  }

  function flush() {
    var batch = queue.splice(0, queue.length);
    if (!batch.length) return;

    // Vent ÉN gang kort på Intelligems (max 1 s), så gruppe-tildelingen kan nå
    // med i første kald — ellers ville testdeltagere se basispriser i et blink
    // og få dem udskiftet. Er igData der allerede (eller kommer ig:ready før
    // timeout), fortsætter vi med det samme. Er Intelligems slet ikke på siden,
    // ventes der ikke.
    if (!igWaited && !igReady && !window.igData && igOnPage()) {
      igWaited = true;
      queue = batch.concat(queue);
      var proceeded = false;
      var proceed = function () {
        if (proceeded) return;
        proceeded = true;
        clearTimeout(timer);
        window.removeEventListener('ig:ready', proceed);
        flush();
      };
      var timer = setTimeout(proceed, 1000);
      window.addEventListener('ig:ready', proceed);
      return;
    }

    var appUrl = batch[0].dataset.appUrl.replace(/\/+$/, '');
    var currency = batch[0].dataset.currency || 'EUR';
    var market = batch[0].dataset.country || ''; // landekode → regler kan scopes pr. marked
    // Kundens sprog (request.locale.iso_code) → appen sender reglens egne tekster
    // (labels, badge-tekster, enhed) oversat (rabatmotor SPEC §7m). Tom = originalen.
    var locale = batch[0].dataset.locale || '';

    var byHandle = {};
    var items = [];
    batch.forEach(function (el) {
      var handle = el.dataset.handle;
      if (!handle) return;
      (byHandle[handle] = byHandle[handle] || []).push(el);
      if (byHandle[handle].length === 1) {
        items.push({ handle: handle, tags: el.dataset.tags || '', collections: el.dataset.collections || '' });
      }
    });
    if (!items.length) return;

    var igGroups = collectIgGroups();
    igSentGroups = igGroups.slice().sort().join(','); // husk hvad vi sendte → re-fetch ved senere ændring
    syncCartIgAttribute(igGroups); // hold kurv-attributten i sync (fase 2 — rabat-motor)

    // Del kaldet op i portioner: temaets collection-grid kan indlæse ALLE
    // kollektionens produkter til klient-side-filtrering (850+ kort på
    // /collections/all på atlantic), og ét samlet kald blev afvist af serveren
    // som for stort (413) — så ingen kort fik tiers. Appen svarer desuden
    // højst på 250 produkter pr. kald. Hver portion renderer for sig.
    for (var start = 0; start < items.length; start += MAX_ITEMS_PER_REQUEST) {
      sendOffers(appUrl, currency, market, igGroups, items.slice(start, start + MAX_ITEMS_PER_REQUEST), byHandle, locale);
    }
  }

  var MAX_ITEMS_PER_REQUEST = 80; // ≈ 20 kB body med tags + collections

  function sendOffers(appUrl, currency, market, igGroups, items, byHandle, locale) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (controller) setTimeout(function () { controller.abort(); }, 8000);

    fetch(appUrl + '/api/v1/offers', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // shop: myshopify-domænet — appen shop-opløser reglerne (multi-shop)
      body: JSON.stringify({ currency: currency, market: market, locale: locale || '', ig_groups: igGroups, items: items, shop: (window.Shopify && window.Shopify.shop) || '' }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.offers) { clearSsrAll(items, byHandle); return; }
        // Perf (INP): alle kort renderes først, og enheds-prisen måles derefter
        // samlet (fitBatch) — ellers tvang hvert kort sin egen layout-beregning.
        fitDeferred = [];
        try {
          renderOffers(data, items, byHandle);
        } finally {
          var toFit = fitDeferred;
          fitDeferred = null;
          fitBatch(toFit);
        }
      })
      .catch(function () { clearSsrAll(items, byHandle); /* fail-safe: normalpris-vaelger eller temaets pris/knap */ });
  }

  function renderOffers(data, items, byHandle) {
        items.forEach(function (item) {
          var offer = data.offers[item.handle];
          var hasTiers = !!(offer && offer.tiers && offer.tiers.length);
          if (!hasTiers) {
            // Ingen antals-regel → normalpris-vaelger (data-default-packs) eller ryd SSR,
            // saa temaets egen pris/knap kommer tilbage (CSS :has() slipper).
            // Gave-regel (X+Y) uden trin: gave-linjen vises alligevel.
            (byHandle[item.handle] || []).forEach(function (el) {
              renderFallbackOrClear(el);
              el.renderGift(offer && offer.gift);
            });
            return;
          }
          (byHandle[item.handle] || []).forEach(function (el) {
            // Oversat enhed har sin egen flertalsform (fx "Dose"/"Dosen") — ellers "+s"
            el._unitPlural = (typeof offer.unit_plural === 'string' && offer.unit_plural.trim()) ? offer.unit_plural.trim() : null;
            el.renderTiers(offer.tiers, offer.unit, offer.highlight_box, offer.ends_at, offer.max_units);
            el.renderGift(offer.gift);
          });
        });
  }

  // Produkter UDEN regel: samme pack-vaelger til NORMALPRIS (0 %-trin for de
  // pakkestoerrelser temaet angiver i data-default-packs, fx "3,5,10"). Tom
  // attribut = ryd SSR og lad temaets egen pris/knap staa (som foer).
  function renderFallbackOrClear(el) {
    var packs = (el.dataset.defaultPacks || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return isFinite(n) && n > 1; });
    if (!packs.length) { clearSsr(el); return; }
    el.renderTiers(packs.map(function (q) { return { qty: q, type: 'percent', value: 0 }; }), 'can');
  }

  // Serverrenderet tier-liste (qty-tiers-ssr.liquid) ligger i elementet ved
  // foerste svar. Den fjernes igen naar appen svarer (renderTiers toemmer
  // elementet) ELLER naar der intet svar/ingen regel er — ellers ville et
  // kort staa med en statisk liste uden add-to-cart.
  function clearSsr(el) {
    if (el.querySelector('.qty-tiers__box--ssr, .qty-tiers__pdp--ssr')) el.innerHTML = '';
    removeSsrBadge(el.closest('[data-js-product-item]') || el.closest('.main-product'));
  }
  // Den serverrenderede roede badge (qty-tiers-promo-badge.liquid, data-ssr="1")
  // fjernes, naar appens svar IKKE har en promo-tier (regel aendret) eller der
  // slet intet svar/regel er — saa badgen aldrig lover en rabat, kurven ikke giver.
  function removeSsrBadge(scope) {
    if (!scope) return;
    scope.querySelectorAll('.qty-tiers__promo-badge[data-ssr]').forEach(function (b) { b.remove(); });
  }
  function clearSsrAll(items, byHandle) {
    items.forEach(function (item) { (byHandle[item.handle] || []).forEach(renderFallbackOrClear); });
  }

  // Charm: dåse-pris (cents) til nærmeste beløb der ender på 9; lige langt → ned;
  // op kun hvis den afrundede procent stadig er mindst trinnets (samme test som
  // kurvens charm_unit i main.rs og qty-tiers-ssr.liquid).
  function charmUnit(unit, base, pct) {
    var r = unit % 10;
    var lo = r === 9 ? unit : unit - r - 1;
    var hi = lo + 10;
    if (lo <= 0) return unit;
    if (unit - lo <= hi - unit) return lo;
    return 200 * (base - hi) > (2 * pct - 1) * base ? hi : lo;
  }

  // Shopify-pengeformat som temaets _formatMoney (component-product-form.js), uden
  // valutakode-suffiks — svarer til Liquid `money`. Ukendt placeholder → null.
  function formatShopMoney(cents, format) {
    function delimit(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/)[1];
    var value = {
      amount: function () { return delimit(2, ',', '.'); },
      amount_no_decimals: function () { return delimit(0, ',', '.'); },
      amount_with_comma_separator: function () { return delimit(2, '.', ','); },
      amount_no_decimals_with_comma_separator: function () { return delimit(0, '.', ','); },
      amount_with_space_separator: function () { return delimit(2, ' ', ','); },
      amount_no_decimals_with_space_separator: function () { return delimit(0, ' ', ','); },
      amount_with_apostrophe_separator: function () { return delimit(2, "'", '.'); }
    }[placeholder];
    return value ? format.replace(/\{\{\s*\w+\s*\}\}/, value()) : null;
  }

  function formatMoney(amount, currency, locale) {
    // UK-markedet: display-only GBP (kunden betaler EUR) — se ESGBP i theme.liquid
    if (window.ESGBP && window.ESGBP.enabled && currency === 'EUR') {
      return window.ESGBP.formatAmount(amount);
    }
    // Butikkens eget pengeformat (fx "€{{amount_with_comma_separator}}" → "€39,90"),
    // samme som temaets Liquid `money` og den serverrenderede liste — ellers skifter
    // "39,90" til "39.90", når widget'en overtager. Intl er kun fallback.
    var shopFormat = window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format;
    if (typeof shopFormat === 'string' && /\{\{\s*\w+\s*\}\}/.test(shopFormat)) {
      var formatted = formatShopMoney(Math.round(amount * 100), shopFormat);
      if (formatted) return formatted;
    }
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  // Oversatte tekster leveres af qty-tiers.liquid som data-t-*-attributter
  // (locale-keys under "rabatmotor" + temaets add_to_cart_button — LangShop-venlige).
  // Mangler attributten (fx gammel cache), falder vi tilbage til engelsk.
  function t(el, key, fallback) {
    var value = el.dataset[key];
    return (typeof value === 'string' && value.trim()) ? value : fallback;
  }

  // "10-pack" / "10-pak" / "10er-Pack" — skabelon fra locale ({qty} erstattes)
  function packLabel(el, qty) {
    return escapeHtml(t(el, 'tPack', '{qty}-pack').replace(/\{qty\}/g, qty));
  }

  var CHEVRON = '<svg class="qty-tiers__chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK = '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 5l3.5 3.5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var QtyTiers = function () {
    return Reflect.construct(HTMLElement, [], QtyTiers);
  };
  QtyTiers.prototype = Object.create(HTMLElement.prototype);
  QtyTiers.prototype.constructor = QtyTiers;
  Object.setPrototypeOf(QtyTiers, HTMLElement);

  QtyTiers.prototype.connectedCallback = function () {
    if (this._registered) return;
    this._registered = true;
    // Preview-tilstand (design-review uden app): statiske demo-tiers fra Liquid
    if (this.dataset.preview) {
      try { this.renderTiers(JSON.parse(this.dataset.preview)); } catch (e) { /* ignore */ }
      return;
    }
    if (!this.dataset.appUrl || !this.dataset.handle) return;
    this.wireSsr(); // serverrenderet boks: knap/trigger/raekker virker foer appens svar
    enqueue(this);
  };

  // Den serverrenderede kort-boks (qty-tiers-ssr.liquid) ligger i elementet fra
  // foerste paint. Indtil appen har svaret og renderTiers har erstattet den, skal
  // den kunne bruges: trigger aabner/lukker panelet, en raekke vaelges, og
  // Add-to-cart laegger den valgte raekkes antal i kurven via temaets form.
  // Lytterne forsvinder med elementerne, naar renderTiers toemmer boksen.
  QtyTiers.prototype.wireSsr = function () {
    var box = this.querySelector('.qty-tiers__box--ssr');
    if (!box) return;
    var self = this;
    var panel = box.querySelector('.qty-tiers__panel');
    var trigger = box.querySelector('.qty-tiers__trigger');
    var atc = box.querySelector('.qty-tiers__atc');
    if (trigger && panel) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        panel.hidden = !panel.hidden;
      });
    }
    // Minimér-knappen øverst i panelet (samme markup som render()) — uden den
    // ville et aabnet SSR-panel kun kunne lukkes ved at vaelge en raekke.
    var minimize = box.querySelector('.qty-tiers__minimize');
    if (minimize && panel) {
      minimize.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        panel.hidden = true;
      });
    }
    box.querySelectorAll('.qty-tiers__option').forEach(function (row) {
      row.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (row.classList.contains('qty-tiers__option--soldout')) return; // udsolgt trin
        box.querySelectorAll('.qty-tiers__option').forEach(function (r) {
          var on = r === row;
          r.classList.toggle('is-selected', on);
          r.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (atc && row.dataset.qty) atc.dataset.qty = row.dataset.qty;
        if (panel) panel.hidden = true;
      });
    });
    if (atc) {
      atc.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var qty = parseInt(atc.dataset.qty, 10);
        self.addToCart(atc, isFinite(qty) && qty > 0 ? qty : 1);
      });
    }
  };

  QtyTiers.prototype.renderTiers = function (tiers, unit, highlightBox, endsAt, maxUnits) {
    var unitPrice = parseInt(this.dataset.price, 10) / 100; // Liquid-pris er i cents
    var currency = this.dataset.currency || 'EUR';
    var locale = this.dataset.locale || undefined;
    this._unit = (typeof unit === 'string' && unit.trim()) ? unit.trim() : 'can';
    this._endsAt = endsAt || null; // reglens slutdato (ISO) — bruges i badge-teksten ({ends})
    clearSsr(this); // serverrenderet liste vaek foer vi evt. returnerer tidligt
    if (!isFinite(unitPrice) || unitPrice <= 0) return;
    // Deal-regel (appens max_units, fx 0,99-deals: 1 stk til 0,99): kun trin op til
    // max_units vises, og et 1-stk-trin ERSTATTER "1 stk til normalpris", så
    // normalprisen aldrig står ved siden af deal-prisen. Kurven regner det samme.
    var maxQty = (isFinite(maxUnits) && maxUnits > 0) ? maxUnits : 0;
    // Lagerloft (data-stock fra Liquid: kun Shopify-lagerstyring med 'deny'):
    // trin over lageret vises ikke, saa kunden ikke kan vaelge mere end der er.
    var stock = parseInt(this.dataset.stock, 10);
    var hasStock = this.dataset.stock !== undefined && this.dataset.stock !== '' && isFinite(stock);
    if (hasStock && stock < 1) return; // reelt udsolgt — intet at vaelge
    var stockCapped = false;

    var options = [{ qty: 1, total: unitPrice }];
    var baseReplaced = false;
    // Charm-loft (2/11-2026): et STØRRE procent-trin må aldrig give en dyrere
    // dåse-pris end et mindre charm-trin. Med samme % på 10/30/50 runder charm
    // 10'eren ned (3,80 → 3,79), mens 30/50 er rene procenter (3,80). Derfor:
    // dåse-pris = min(egen, charm-dåse-prisen på hvert mindre charm-trin).
    // Samme regel i kurven (main.rs charm_floor) og qty-tiers-ssr.liquid.
    var baseCents = Math.round(unitPrice * 100);
    var charmFloors = [];
    tiers.forEach(function (t) {
      if (!t || !t.charm || t.type !== 'percent' || !isFinite(t.qty) || !isFinite(t.value)) return;
      var u = Math.ceil(baseCents * (1 - t.value / 100) - 1e-9);
      charmFloors.push({ qty: t.qty, unit: charmUnit(u, baseCents, t.value) });
    });
    tiers.forEach(function (t) {
      if (!t || !isFinite(t.qty) || t.qty < 1) return;
      if (maxQty && t.qty > maxQty) return;
      // Over lageret: trinet VISES stadig, men nedtonet og overstreget, saa
      // kunden kan se at pakken findes — den kan bare ikke vaelges lige nu.
      var soldOut = hasStock && t.qty > stock;
      if (soldOut) stockCapped = true;
      var full = Math.round(unitPrice * t.qty * 100) / 100; // afrund som total, ellers dropper floating-point 0%-tiers
      var total;
      if (t.type === 'percent') {
        // Match Intelligems: rabatten regnes PR. ENHED, og RABATBELØBET rundes
        // NED = den rabatterede enhedspris rundes OP til hele cents (ceil).
        // Verificeret mod kurven: 4.41 −16% = 3.7044 → Intelligems opkræver
        // 3.71 (ikke 3.70), og 6.62 −20% = 5.296 → 5.30. Almindelig round()
        // gav 3.70 her → widget viste 10 cent mindre end checkout.
        // −1e-9 = floating-point-værn så eksakte beløb (fx 4.50) ikke ceiler op.
        var discountedUnitCents = Math.ceil(Math.round(unitPrice * 100) * (1 - t.value / 100) - 1e-9);
        var discountedUnit = discountedUnitCents / 100;
        total = Math.round(discountedUnit * t.qty * 100) / 100;
        // Charm-trin (appens charm: true): dåse-prisen til nærmeste ,x9 (4,04 →
        // 3,99), men aldrig op hvis procenten så viser under trinnets. Pakken er
        // dåse × antal. Samme regnestykke som kurven (main.rs charm_unit).
        if (t.charm) {
          discountedUnitCents = charmUnit(discountedUnitCents, Math.round(unitPrice * 100), t.value);
          total = discountedUnitCents * t.qty / 100;
        }
        // Charm-loft (se charmFloors ovenfor)
        var capped = discountedUnitCents;
        charmFloors.forEach(function (f) { if (f.qty < t.qty && f.unit < capped) capped = f.unit; });
        if (capped < discountedUnitCents) {
          discountedUnitCents = capped;
          total = discountedUnitCents * t.qty / 100;
        }
        if (total > full) return; // procent kan aldrig gøre det dyrere — defensivt
      } else if (t.type === 'fixed_total') {
        total = t.total; // eksplicit fast pris — vises altid, også uden rabat
      } else {
        return;
      }
      if (!isFinite(total) || total <= 0) return;
      if (t.qty === 1) {
        // 1-stk-trin (deal/fast pris): erstatter normalprisen i stedet for at stå ved siden af
        if (total < unitPrice) { options[0] = { qty: 1, total: total, label: t.label || null }; baseReplaced = true; }
        return;
      }
      options.push({ qty: t.qty, total: total, label: t.label || null, soldOut: soldOut });
    });
    // Ingen tiers → intet widget (som foer). Undtagelse: lageret klippede trinene
    // vaek — saa vises 1-pack + knap alligevel, saa kortet ser ud som de andre.
    if (options.length < 2 && !baseReplaced && !stockCapped) return;
    options.sort(function (a, b) { return a.qty - b.qty; });

    var self = this;
    this._options = options;
    this._baseReplaced = baseReplaced;
    // Normalpris pr. enhed (produktets pris) — ALLE "spar"-procenter regnes herfra,
    // ogsaa naar 1 stk selv har rabat (ellers viser fx 50 % paa alle trin "0 %").
    this._basePrice = unitPrice;
    this._currency = currency;
    this._locale = locale;
    // Default-valg: 1) tier med badge (marketing styrer), 2) 10-pack, 3) midterste.
    // Uden nogen rabat (normalpris-vaelger for produkter uden regel): 1 stk.
    // Udsolgte trin (over lageret) kan aldrig vaere default — de er vist, men
    // ikke valgbare. Derfor regnes default kun blandt de koebbare.
    var buyable = options.filter(function (o) { return !o.soldOut; });
    var defaultIndex = -1;
    var anyDiscount = baseReplaced || buyable.some(function (o) { return o.qty > 1 && o.total / o.qty < unitPrice - 1e-9; });
    if (!anyDiscount) defaultIndex = 0;
    for (var i = 0; i < options.length && defaultIndex === -1; i++) {
      if (options[i].label && !options[i].soldOut) { defaultIndex = i; break; }
    }
    if (defaultIndex === -1) {
      for (var j = 0; j < options.length; j++) {
        if (options[j].qty === 10 && !options[j].soldOut) { defaultIndex = j; break; }
      }
    }
    if (defaultIndex === -1 && buyable.length) {
      var mid = buyable[Math.floor(buyable.length / 2)];
      for (var k = 0; k < options.length; k++) {
        if (options[k] === mid) { defaultIndex = k; break; }
      }
    }
    // Sidste vaern: landede vi alligevel paa et udsolgt trin, tag det stoerste
    // koebbare (ellers 1 stk), saa kurven aldrig faar et antal der ikke findes.
    if (defaultIndex === -1 || (options[defaultIndex] && options[defaultIndex].soldOut)) {
      defaultIndex = 0;
      for (var n = options.length - 1; n >= 0; n--) {
        if (!options[n].soldOut) { defaultIndex = n; break; }
      }
    }
    this._selected = defaultIndex;

    // Tier markeret til rød rabat-badge — bruges af både kort- og PDP-stien.
    var promoTier = null;
    for (var p = 0; p < tiers.length; p++) {
      var pt = tiers[p];
      if (pt && pt.promo && pt.type === 'percent' && isFinite(pt.qty) && pt.qty >= 1 && isFinite(pt.value) && pt.value > 0) {
        promoTier = pt;
        break;
      }
    }

    // Produktside: egen render-sti (åben liste, ingen trigger/panel/ATC).
    if (!promoTier) removeSsrBadge(this.closest('[data-js-product-item]') || this.closest('.main-product'));
    if (this.dataset.pdp) { this.renderPdp(options, promoTier); return; }

    this.innerHTML = '';
    var box = document.createElement('div');
    box.className = 'qty-tiers__box';

    // --- Opklappeligt panel ---
    var panel = document.createElement('div');
    panel.className = 'qty-tiers__panel';
    panel.hidden = true;

    var minimize = document.createElement('button');
    minimize.type = 'button';
    minimize.className = 'qty-tiers__minimize';
    minimize.innerHTML = escapeHtml(t(this, 'tMinimize', 'Minimize')) + ' ' + CHEVRON;
    minimize.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      self.closePanel();
    });
    panel.appendChild(minimize);

    var list = document.createElement('div');
    list.className = 'qty-tiers__options';
    list.setAttribute('role', 'radiogroup');
    options.forEach(function (opt, index) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'qty-tiers__option' + (opt.soldOut ? ' qty-tiers__option--soldout' : '');
      row.setAttribute('role', 'radio');
      if (opt.soldOut) {
        row.disabled = true;
        row.setAttribute('aria-disabled', 'true');
      }
      // Besparelse i % vs. normalpris — mini-badge ("−10%") der svæver lige over
      // prisen (absolut positioneret, skubber ALDRIG til layoutet). Beregnes af
      // totalerne, så fixed_total-tiers også får korrekt procent.
      var pctOff = Math.round((1 - (opt.total / opt.qty) / unitPrice) * 100);
      row.innerHTML =
        '<span class="qty-tiers__option-qty">' + packLabel(self, opt.qty) +
          (opt.label ? ' <em class="qty-tiers__option-label">' + escapeHtml(opt.label) + '</em>' : '') +
        '</span>' +
        '<span class="qty-tiers__option-price">' + formatMoney(opt.total, currency, locale) +
          (pctOff >= 1 ? '<span class="qty-tiers__option-pct">&minus;' + pctOff + '%</span>' : '') +
        '</span>' +
        '<span class="qty-tiers__option-radio">' + CHECK + '</span>';
      row.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (opt.soldOut) return; // udsolgt trin: vist, men ikke valgbart
        self.select(index);
        self.closePanel();
      });
      list.appendChild(row);
    });
    panel.appendChild(list);
    box.appendChild(panel);

    // --- Kollapset trigger-række ---
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'qty-tiers__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (panel.hidden) self.openPanel();
      else self.closePanel();
    });
    box.appendChild(trigger);

    // --- Add to cart ---
    var atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'qty-tiers__atc';
    atc.textContent = t(this, 'tAtc', 'Add to cart');
    atc.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      self.addToCart(atc);
    });
    box.appendChild(atc);

    this.appendChild(box);
    this._panel = panel;
    this._trigger = trigger;
    this.select(this._selected); // sætter også temaets quantity-input i sync

    // Skjul temaets egen quick-buy i kortet — widget'en overtager add-to-cart.
    var card = this.closest('[data-js-product-item]');
    if (card) card.classList.add('qty-tiers-rendered');

    // Regel-flag: fremhæv temaets sorte promo-boks (.box2) med rød tilbuds-effekt.
    if (highlightBox && card) card.classList.add('qty-tiers-box-highlight');

    // Rød rabat-badge i kortets hjørne ("20% OFF AT 10 CANS") — tier markeret i appen.
    if (promoTier && card) this.renderPromoBadge(promoTier, card);
  };

  // Produktside-liste i Intelligems-stil: altid-åbne radio-rækker med antal,
  // "Save X%"-chip, totalpris (fed) og pris/enhed. Ingen egen add-to-cart —
  // temaets native knap bruges; rækker sætter kun form'ens quantity-input.
  QtyTiers.prototype.renderPdp = function (options, promoTier) {
    var self = this;
    var baseUnitPrice = this._basePrice; // normalpris pr. enhed (ikke 1 stk-trinets evt. rabatpris)

    this.innerHTML = '';
    var box = document.createElement('div');
    box.className = 'qty-tiers__pdp';

    var list = document.createElement('div');
    list.className = 'qty-tiers__pdp-options';
    list.setAttribute('role', 'radiogroup');
    options.forEach(function (opt, index) {
      var unitPrice = opt.total / opt.qty;
      // Besparelse vs. normalpris — beregnes af totalerne så fixed_total-tiers også får chip
      var savePct = Math.round((1 - unitPrice / baseUnitPrice) * 100);
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'qty-tiers__option qty-tiers__option--pdp' + (opt.soldOut ? ' qty-tiers__option--soldout' : '');
      row.setAttribute('role', 'radio');
      if (opt.soldOut) {
        row.disabled = true;
        row.setAttribute('aria-disabled', 'true');
      }
      row.innerHTML =
        '<span class="qty-tiers__option-radio">' + CHECK + '</span>' +
        '<span class="qty-tiers__option-qty">' + packLabel(self, opt.qty) +
          (opt.label ? ' <em class="qty-tiers__option-label">' + escapeHtml(opt.label) + '</em>' : '') +
        '</span>' +
        (savePct >= 1 ? '<span class="qty-tiers__option-save">' + escapeHtml(t(self, 'tSave', 'Save {save}').replace(/\{save\}/g, savePct + '%')) + '</span>' : '') +
        '<span class="qty-tiers__option-price qty-tiers__option-price--pdp">' +
          '<strong>' + formatMoney(opt.total, self._currency, self._locale) + '</strong>' +
          '<small>' + formatMoney(unitPrice, self._currency, self._locale) + '/' + escapeHtml(self._unit) + '</small>' +
        '</span>';
      row.addEventListener('click', function (event) {
        event.preventDefault();
        if (opt.soldOut) return; // udsolgt trin: vist, men ikke valgbart
        self.select(index);
      });
      list.appendChild(row);
    });
    box.appendChild(list);
    this.appendChild(box);

    this._panel = null;
    this._trigger = null;
    this.select(this._selected); // preselect default-tier + sync form-quantity

    // Skjul temaets egen qty-selector og enkeltpris — widget'en ejer nu valget.
    var page = this.closest('.main-product');
    if (page) page.classList.add('main-product--qt');

    // Rød rabat-badge i galleriets hjørne — samme placering som temaets
    // almindelige sale-badge på produktsiden (product-badges i .product-gallery).
    if (promoTier && page) this.renderPromoBadge(promoTier, page);
  };

  // Badge i samme stil som temaets sale-badge (product-badges.liquid): samme
  // container/klasser, farver fra settings via data-attrs (fallback rød/hvid).
  // scope = produktkortet ([data-js-product-item]) eller product-page (.main-product) —
  // på PDP sidder badge-containeren i galleriet, samme hjørne som temaets sale-badge.
  QtyTiers.prototype.renderPromoBadge = function (tier, scope) {
    if (scope.querySelector('.qty-tiers__promo-badge')) return; // allerede sat (re-render)
    // Er der allerede en sale-badge (compare-at-pris eller 2for1/3for2-tags),
    // viger vi — to rabat-badges oven i hinanden forvirrer mere end de sælger.
    if (scope.querySelector('.product-item__badge--sale')) return;
    var container = scope.querySelector('.product-item__badges');
    if (!container) {
      // Temaets badges kan være slået fra (settings.show_badges) — lav containeren selv.
      container = document.createElement('div');
      container.className = 'product-item__badges text-size--xsmall';
      // PDP: containeren skal ligge i galleriet for at få hjørne-positioneringen
      (scope.querySelector('.product-gallery') || scope).appendChild(container);
    }
    var badge = document.createElement('span');
    badge.className = 'product-item__badge product-item__badge--sale qty-tiers__promo-badge';
    badge.style.backgroundColor = this.dataset.badgeBg || '#e02b27';
    badge.style.color = this.dataset.badgeTextColor || '#ffffff';
    var pct = Math.round(tier.value * 10) / 10; // 12.5 bevares, 20.0 → 20
    var unit = this._unit || 'can';
    // Naiv flertalsform: "10 can" → "10 cans" (springes over hvis enheden allerede ender på s)
    // — men en oversat enhed fra appen har sin rigtige flertalsform (unit_plural)
    var unitText = tier.qty > 1 ? (this._unitPlural || (!/s$/i.test(unit) ? unit + 's' : unit)) : unit;
    // Reglens slutdato → "Jul 27" / "27. jul." — formateret efter kundens locale
    var endsText = this._endsAt ? formatEndsDate(this._endsAt, this._locale) : '';
    // Teksten er en skabelon fra regel-editoren; {percent}/{qty}/{unit}/{ends} erstattes.
    // Standarden (fra locale-filerne) tilføjer selv slutdatoen når reglen har en —
    // custom tekst fra editoren styrer 100 % selv (appen sender den oversat, SPEC §7n).
    var custom = typeof tier.promoText === 'string' && tier.promoText.trim() ? tier.promoText : null;
    // Rabat fra 1 stk (fx mixpacks i en kampagne): "50% off" uden "at 1 can"
    var base = tier.qty === 1
      ? t(this, 'tBadgeAll', '{percent}% off')
      : t(this, 'tBadge', '{percent}% off at {qty} {unit}');
    var fullTemplate = custom || base + (endsText ? ' ' + t(this, 'tBadgeEnds', '– ends {ends}') : '');
    // Kort variant til telefoner: uden slutdato. Custom tekst har {ends} inde i
    // sin egen skabelon, så der fjernes pladsholderen og en evt. hængende tankestreg.
    var shortTemplate = custom || base;
    function fill(template, ends) {
      var out = template
        .replace(/\{percent\}/g, pct)
        .replace(/\{qty\}/g, tier.qty)
        .replace(/\{unit\}/g, unitText)
        .replace(/\{ends\}/g, ends)
        .replace(/\s{2,}/g, ' ') // custom tekst med {ends} men ingen slutdato → ryd dobbelt-mellemrum
        .trim();
      // Uden dato må "… – " ikke stå tilbage med en tom hale
      return ends ? out : out.replace(/[\s]*[–—-]+\s*$/, '').trim();
    }
    badge.dataset.textFull = fill(fullTemplate, endsText);
    badge.dataset.textShort = fill(shortTemplate, '');
    badge.textContent = badge.dataset.textFull; // fitteren vælger den rigtige variant
    container.appendChild(badge);
    // Krympning/tekstvariant håndteres centralt i product-card-titles.js, som
    // gør det samme for temaets egne Liquid-badges (og har resize-lytteren).
    if (typeof window.fitProductBadges === 'function') window.fitProductBadges(badge);
  };

  // Gave-regel (X+Y / x+x) fra appens offer.gift: { buy, get, title, handle } —
  // eller beloebs-gave { spend, get, ... } ("Buy for €50, get 1 × Velo Ice free";
  // spend er i kortets valuta, efter maengderabat). Viser en linje under
  // vaelgeren og en badge i kortets/galleriets hjoerne ("5 + 1 FREE"). Selve
  // gaven laegges i kurven af rm-gifts.js, og kurv-funktionen goer den gratis.
  // null = fjern (regel vaek).
  QtyTiers.prototype.renderGift = function (gift) {
    var scope = this.closest('[data-js-product-item]') || this.closest('.main-product');
    var old = this.querySelector('.qty-tiers__gift');
    if (old) old.remove();
    if (scope) scope.querySelectorAll('.qty-tiers__gift-badge').forEach(function (b) { b.remove(); });
    if (!gift || !(gift.get >= 1) || !(gift.buy >= 1 || gift.spend > 0)) return;
    if (gift.hide_badge) return; // skjul både badgen og "Buy 1, get 1 free"-linjen
    var bySpend = !(gift.buy >= 1);
    // x+x: gaven er produktet selv — fast gave-produkt = kortets, eller reglen
    // giver "samme produkt" som kunden koeber (gift.same, hele kollektioner)
    var same = !!gift.same || (!!gift.handle && gift.handle === this.dataset.handle);
    // "€50,00" → "€50": hele beloeb uden decimaler
    var amount = bySpend
      ? formatMoney(Number(gift.spend), this.dataset.currency || 'EUR', this.dataset.locale || undefined).replace(/([.,])00(?!\d)/, '')
      : '';
    // Reglens slutdato til {ends} i en egen badge-tekst ("Nov 30" / "30. nov.")
    var endsText = gift.ends_at ? formatEndsDate(gift.ends_at, this._locale || this.dataset.locale || undefined) : '';
    var fill = function (template) {
      return template
        .replace(/\{buy\}/g, gift.buy)
        .replace(/\{amount\}/g, amount)
        .replace(/\{get\}/g, gift.get)
        .replace(/\{title\}/g, gift.title || '')
        .replace(/\{ends\}/g, endsText);
    };
    var line = document.createElement('div');
    line.className = 'qty-tiers__gift';
    if (bySpend) {
      line.textContent = fill(same
        ? t(this, 'tGiftSpendSame', 'Buy for {amount}, get {get} free')
        : t(this, 'tGiftSpendLine', 'Buy for {amount}, get {get} × {title} free'));
    } else {
      line.textContent = fill(same
        ? t(this, 'tGiftSame', 'Buy {buy}, get {get} free')
        : t(this, 'tGiftLine', 'Buy {buy}, get {get} × {title} free'));
    }
    this.appendChild(line);

    if (!scope || gift.hide_badge) return;
    var container = scope.querySelector('.product-item__badges');
    if (!container) {
      container = document.createElement('div');
      container.className = 'product-item__badges text-size--xsmall';
      (scope.querySelector('.product-gallery') || scope).appendChild(container);
    }
    var badge = document.createElement('span');
    badge.className = 'product-item__badge product-item__badge--sale qty-tiers__gift-badge';
    badge.style.backgroundColor = this.dataset.badgeBg || '#e02b27';
    badge.style.color = this.dataset.badgeTextColor || '#ffffff';
    // Egen tekst fra regel-editoren (gift.badge) vinder over locale-standarden —
    // én tekst til alle sprog. Uden slutdato ryddes en hængende "– {ends}"-hale.
    var custom = typeof gift.badge === 'string' && gift.badge.trim() ? gift.badge : null;
    var badgeText = custom
      ? fill(custom).replace(/\s{2,}/g, ' ').trim()
      : fill(bySpend
        ? t(this, 'tGiftSpendBadge', '{amount} → {get} free')
        : t(this, 'tGiftBadge', '{buy} + {get} free'));
    if (custom && !endsText) badgeText = badgeText.replace(/[\s]*[–—-]+\s*$/, '').trim();
    badge.textContent = badgeText;
    badge.dataset.textFull = badge.textContent;
    badge.dataset.textShort = badge.textContent;
    container.appendChild(badge);
    if (typeof window.fitProductBadges === 'function') window.fitProductBadges(badge);
  };

  QtyTiers.prototype.openPanel = function () {
    if (openWidget && openWidget !== this) openWidget.closePanel();
    this._panel.hidden = false;
    this._trigger.setAttribute('aria-expanded', 'true');
    openWidget = this;
  };

  QtyTiers.prototype.closePanel = function () {
    if (!this._panel) return;
    this._panel.hidden = true;
    this._trigger.setAttribute('aria-expanded', 'false');
    if (openWidget === this) openWidget = null;
  };

  QtyTiers.prototype.select = function (index) {
    // Udsolgte trin kan ikke vaelges — hverken ved klik eller programmatisk,
    // saa temaets quantity-input aldrig faar et antal der ikke er paa lager.
    var target = this._options && this._options[index];
    if (!target || target.soldOut) return;
    this._selected = index;
    this.updateSelected();
    // Hold temaets quantity-input i sync, så temaets form tilføjer det rigtige antal.
    var input = null;
    var card = this.closest('[data-js-product-item]');
    if (card) {
      input = card.querySelector('input[name="quantity"]');
    } else if (this.dataset.pdp) {
      // PDP: quantity-inputtet sidder i temaets product-form (skjult af CSS, men submitter stadig).
      var page = this.closest('.main-product');
      var form = page && page.querySelector('product-form form[action*="/cart/add"]');
      if (form) {
        input = form.querySelector('input[name="quantity"]');
        if (!input) {
          // buy_buttons uden qty-selector-block: lav et hidden input så antallet stadig sendes med
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }
      }
    }
    if (input) {
      input.value = this._options[index].qty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.dataset.pdp) this._updateStickySummary();
  };

  // Sticky-baren viser normalt kun 1-stk-prisen. Med widget'en aktiv erstattes
  // den (CSS skjuler originalen) af en opsummering af valget: "10-pack · 80,00 €"
  // + stk-pris. Opdateres ved hvert tier-valg. Sticky'en hænger på <body>, uden
  // for .main-product — findes den ikke (slået fra i section settings), sker intet.
  QtyTiers.prototype._updateStickySummary = function () {
    var opt = this._options[this._selected];
    var priceBox = document.querySelector('.sticky-add-to-cart .sticky-add-to-cart__price');
    if (!priceBox) return;
    var summary = priceBox.querySelector('.qty-tiers__sticky-summary');
    if (!summary) {
      summary = document.createElement('span');
      summary.className = 'qty-tiers__sticky-summary';
      priceBox.appendChild(summary);
    }
    var unitPrice = opt.total / opt.qty;
    summary.innerHTML =
      '<strong>' + packLabel(this, opt.qty) + ' · ' + formatMoney(opt.total, this._currency, this._locale) + '</strong>' +
      '<small>' + formatMoney(unitPrice, this._currency, this._locale) + '/' + escapeHtml(this._unit) + '</small>';
  };

  QtyTiers.prototype.updateSelected = function () {
    var opt = this._options[this._selected];
    var unit = opt.total / opt.qty;
    // Besparelse for det valgte tier — vises som mini-pille foran totalprisen
    // (regnet mod normalprisen, ogsaa naar 1 stk-trinet selv har rabat).
    var pctOff = Math.round((1 - unit / this._basePrice) * 100);
    // PDP-tilstand har ingen trigger — kun rækkernes is-selected/aria skal opdateres.
    if (this._trigger) this._trigger.innerHTML =
      '<span class="qty-tiers__trigger-qty">' + packLabel(this, opt.qty) + ' ' + CHEVRON + '</span>' +
      '<span class="qty-tiers__trigger-price">' +
        // Pakke-prisen er den fremhævede (fede); besparelse + stk-pris vises
        // diskret nedenunder (som Haypp). _fitUnitText krymper den fede linje,
        // hvis den ikke kan være på én linje.
        '<strong>' + formatMoney(opt.total, this._currency, this._locale) + '</strong>' +
        '<small>' +
          // Ingen litteral space: afstanden til stk-prisen styres alene af
          // pillens margin-right (1px), så den sidder helt tæt på.
          (pctOff >= 1 ? '<span class="qty-tiers__trigger-pct">&minus;' + pctOff + '%</span>' : '') +
          // Stk-pris og /enhed må aldrig brydes fra hinanden ("30,24 €/Mixpack").
          '<span class="qty-tiers__trigger-unit">' +
            '<span class="qty-tiers__trigger-unitprice">' + formatMoney(unit, this._currency, this._locale) + '</span>' +
            '<span class="qty-tiers__trigger-unitname">/' + escapeHtml(this._unit) + '</span>' +
          '</span>' +
        '</small>' +
      '</span>';
    var rows = this.querySelectorAll('.qty-tiers__option');
    var selected = this._selected;
    rows.forEach(function (row, index) {
      row.classList.toggle('is-selected', index === selected);
      row.setAttribute('aria-checked', index === selected ? 'true' : 'false');
    });
    this._fitUnitText();
  };

  // Krymp enheds-prisen ("X €/Mixpack") indtil den passer på én linje uden at
  // flyde ud af kassen. Lange enheds-navne (fx Mixpack) brød ellers over flere
  // linjer eller overflowede. CSS holder white-space:nowrap; her sænkes font-size.
  //
  // Perf (INP): målingen er delt i faser — først nulstilles ALLE elementer, så
  // måles alle, så skrives alle osv. Det giver ~4 layout-beregninger i alt for
  // et helt kort-grid i stedet for ~4 PR. KORT (49 kort ≈ 200 tvungne layouts af
  // hele siden = en lang task på 1-2 s på mobil). Under appens offers-svar
  // samles kortene op (fitDeferred) og måles samlet bagefter.
  QtyTiers.prototype._fitUnitText = function () {
    if (fitDeferred) { if (fitDeferred.indexOf(this) === -1) fitDeferred.push(this); return; }
    fitBatch([this]);
  };

  var fitDeferred = null; // sat til [] mens sendOffers renderer kort

  function fitBatch(list) {
    var jobs = [];
    Array.prototype.forEach.call(list || [], function (el) {
      var priceWrap = el && el._trigger && el._trigger.querySelector('.qty-tiers__trigger-price');
      var unitEl = priceWrap && priceWrap.querySelector('strong'); // pakke-prisen (fed)
      if (!unitEl) return;
      var smallEl = priceWrap.querySelector('small');
      jobs.push({
        unitEl: unitEl,
        // Smalle kort (2x2-layout, se CSS @container): stk-prisen står alene i
        // højre kolonne — lange enheds-navne ("/Mixpack") krympes, så de passer.
        unitWrap: priceWrap.querySelector('.qty-tiers__trigger-unit'),
        // Pillen (−X%) skal flugte med stk-prisens VENSTRE kant: total-linjen får
        // samme bredde som stk-pris-linjen, og flex space-between (CSS) lægger så
        // pillen yderst til venstre og totalen yderst til højre. Er linjen naturligt
        // bredere end stk-prisen (eller uden pille), beholdes naturlig bredde.
        smallEl: smallEl && smallEl.querySelector('.qty-tiers__trigger-pct') ? smallEl : null,
        smallReset: smallEl
      });
    });
    if (!jobs.length) return;

    // 1) skriv: nulstil til CSS-størrelse og mål om teksten passer på ÉN linje
    jobs.forEach(function (j) {
      j.unitEl.style.fontSize = '';
      j.unitEl.style.whiteSpace = 'nowrap';
      if (j.unitWrap) j.unitWrap.style.fontSize = '';
      if (j.smallReset) j.smallReset.style.width = '';
    });
    // 2) læs pakke-prisen. Proportional beregning: tekst-bredde skalerer ~lineært
    //    med font-size → én måling er præcis nok.
    jobs.forEach(function (j) {
      var sw = j.unitEl.scrollWidth;
      var cw = j.unitEl.clientWidth;
      if (sw > cw + 1) {
        var size = parseFloat(getComputedStyle(j.unitEl).fontSize) || 15;
        j.newSize = Math.max(8, size * cw / sw * 0.97);
      }
    });
    // 3) skriv
    jobs.forEach(function (j) {
      if (j.newSize) j.unitEl.style.fontSize = j.newSize + 'px';
    });
    // 4) læs stk-prisen (efter pakke-prisens nye størrelse, som før)
    jobs.forEach(function (j) {
      if (!j.unitWrap) return;
      var sw = j.unitWrap.scrollWidth;
      var cw = j.unitWrap.clientWidth;
      if (sw > cw + 1) {
        var unitSize = parseFloat(getComputedStyle(j.unitWrap).fontSize) || 10;
        j.unitSize = Math.max(7, unitSize * cw / sw * 0.97);
      }
    });
    // 5) skriv
    jobs.forEach(function (j) {
      if (j.unitSize) j.unitWrap.style.fontSize = j.unitSize + 'px';
    });
    // 6) læs bredderne til pille-justeringen
    jobs.forEach(function (j) {
      if (!j.smallEl) return;
      var target = j.unitEl.offsetWidth;
      if (target > j.smallEl.offsetWidth) j.smallWidth = target;
    });
    // 7) skriv
    jobs.forEach(function (j) {
      if (j.smallWidth) j.smallEl.style.width = j.smallWidth + 'px';
    });
  }

  QtyTiers.prototype.addToCart = function (atcButton, qtyOverride) {
    // qtyOverride: den serverrenderede knap (foer appens svar) kender kun antallet
    var opt = qtyOverride ? { qty: qtyOverride } : this._options[this._selected];
    var card = this.closest('[data-js-product-item]');

    // Kurven findes med sikkerhed lige om lidt → skriv gruppe-attributten
    // (fase 2 — rabat-motor), også hvis dette var den allerførste tilføjelse.
    var syncAfterAdd = function () {
      setTimeout(function () { syncCartIgAttribute(collectIgGroups(), true); }, 1500);
    };

    // Foretrukket: proxy temaets egen quick-buy-form (AJAX + cart-drawer er tema-nativt)
    if (card) {
      var form = card.querySelector('quick-add-to-cart form[action*="/cart/add"]');
      if (form) {
        var input = form.querySelector('input[name="quantity"]');
        if (input) input.value = opt.qty;
        var themeButton = form.querySelector('[data-js-product-add-to-cart]');
        if (themeButton) { themeButton.click(); this.flashAdded(atcButton); syncAfterAdd(); return; }
        if (form.requestSubmit) { form.requestSubmit(); this.flashAdded(atcButton); syncAfterAdd(); return; }
      }
      // Flervariant-produkter viser "Choose options"-link → åbn temaets quick view
      var quickView = card.querySelector('quick-view-product a[data-js-product-add-to-cart]');
      if (quickView) { quickView.click(); return; }
    }

    // Fallback uden tema-form: AJAX add + reload (sjældent — fx hvis quick_buy-blocket mangler)
    var self = this;
    atcButton.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(self.dataset.variantId), quantity: opt.qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        syncCartIgAttribute(collectIgGroups(), true);
        window.location.reload();
      })
      .catch(function () { atcButton.disabled = false; });
  };

  QtyTiers.prototype.flashAdded = function (atcButton) {
    var original = atcButton.textContent;
    atcButton.disabled = true;
    atcButton.textContent = t(this, 'tAdded', 'Added ✓');
    setTimeout(function () {
      atcButton.disabled = false;
      atcButton.textContent = original;
    }, 1500);
  };

  // "2026-07-27T00:00:00Z" → "Jul 27" (en) / "27. jul." (da) — forkortet måned
  // (badgen skal kunne stå på ÉN linje), formateret efter kundens locale.
  function formatEndsDate(iso, locale) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var opts = { month: 'short', day: 'numeric' };
    try {
      return new Intl.DateTimeFormat(locale || 'en', opts).format(d);
    } catch (e) {
      // Ukendt locale-tag → engelsk frem for ingen dato
      try { return new Intl.DateTimeFormat('en', opts).format(d); } catch (e2) { return ''; }
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  customElements.define('qty-tiers', QtyTiers);
})();
